import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import ItemCategory from '../../../../components/modules/master/item-category';
import ItemCategoryMiddleware from '../../../../middleware/modules/master/item-category';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
// middlewares


const mapStateToProps = ({ auth,itemCategory }) => ({
  isProcessing: itemCategory.isProcessing,
  isError: itemCategory.isError,
  errorMessage: itemCategory.errorMessage,
  datalist:itemCategory.data,
  showModal:itemCategory.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>ItemCategoryMiddleware.create(),
    reset: () =>ItemCategoryMiddleware.resetList(),
    search: data =>ItemCategoryMiddleware.list(data),
    update: data =>ItemCategoryMiddleware.update(data),
    delete: (id,search) =>ItemCategoryMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class ItemCategoryContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
   this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Item Category List")}
          </title>
        </Helmet>
      <ItemCategory
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemCategoryContainer);
